var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutubeYyfz99(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 28,
    viewBox: "0 0 26 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8554 23.2517C14.7338 23.2517 16.5351 23.0571 18.2045 22.7003C20.2897 22.2546 21.3323 22.0317 22.2837 20.7489C23.2351 19.4662 23.2351 17.9938 23.2351 15.0487V12.9513C23.2351 10.0062 23.2351 8.53373 22.2837 7.25101C21.3323 5.9683 20.2897 5.74544 18.2045 5.29971C16.5351 4.94287 14.7338 4.74829 12.8554 4.74829C10.9769 4.74829 9.17562 4.94287 7.50621 5.29971C5.42101 5.74544 4.37842 5.9683 3.427 7.25101C2.47559 8.53373 2.47559 10.0062 2.47559 12.9513V15.0487C2.47559 17.9938 2.47559 19.4662 3.427 20.7489C4.37842 22.0317 5.42101 22.2546 7.50621 22.7003C9.17562 23.0571 10.9769 23.2517 12.8554 23.2517Z",
    stroke: "#006D33",
    strokeWidth: 1.19577
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.072 14.3451C16.914 15.0133 16.0737 15.4933 14.393 16.4534C12.5648 17.4974 11.6508 18.0195 10.9105 17.8184C10.6598 17.7502 10.4288 17.6304 10.2349 17.4679C9.66235 16.9882 9.66235 15.992 9.66235 13.9999C9.66235 12.0077 9.66235 11.0116 10.2349 10.5318C10.4288 10.3693 10.6598 10.2495 10.9105 10.1814C11.6508 9.98029 12.5648 10.5023 14.393 11.5464C16.0737 12.5065 16.914 12.9864 17.072 13.6547C17.1257 13.8822 17.1257 14.1176 17.072 14.3451Z",
    stroke: "#006D33",
    strokeWidth: 1.19577,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeYyfz99);
export default __webpack_public_path__ + "static/media/youtube_yyfz99.943b2169cbbf00b331ca66885917ee7b.svg";
export { ForwardRef as ReactComponent };